module.exports = __webpack_public_path__ + "img/二维码.c054f251.png";